import { render } from "./radio.vue?vue&type=template&id=85b19336&scoped=true"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"

import "./radio.vue?vue&type=style&index=0&id=85b19336&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b19336"],['__file',"src/components/public/radio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85b19336"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85b19336', __exports__)) {
    console.log('reload')
    api.reload('85b19336', __exports__)
  }
  
  module.hot.accept("./radio.vue?vue&type=template&id=85b19336&scoped=true", () => {
    console.log('re-render')
    api.rerender('85b19336', render)
  })

}


export default __exports__